import { Box, Typography } from "@mui/material";
import { theme } from "app/theme";
import React from "react";
import MarkdownContainer from "./MarkdownContainer";

const InfoSection: React.FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  return (
    <Box marginTop={1.4}>
      <Typography
        fontSize={17}
        fontWeight={600}
        fontFamily={theme.typography.fontFamily}
      >
        {title}
      </Typography>
      <MarkdownContainer content={content} />
    </Box>
  );
};

export default InfoSection;
